export default "__VITE_ASSET__C7Lg5Dk___"